export enum ListFieldWriteModeEnum {
  APPEND = "APPEND",
  NEW_COLUMN = "NEW_COLUMN",
  OVERWRITE = "OVERWRITE",
}
